export const namespace = 'activity'
